class SectionFaq extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['subheading', 'faq']
  }

  checkValidity () {
    super.checkValidity()

    this.els.subheading?.elements.forEach(el => {
      if (!el.dataset.handle) {
        this.throwError('Subheading element must have a data-handle attribute')
      }
    })

    this.els.faq?.elements.forEach(el => {
      if (!el.dataset.handle) {
        this.throwError('Faq element must have a data-handle attribute')
      }
    })
  }

  setupListeners () {
    super.setupListeners()

    this.els.subheading?.elements.forEach(subheadingEl => {
      this.listeners.add(
        subheadingEl,
        'click',
        this.onSubheadingClick.bind(this),
      )
    })
  }

  onSubheadingClick (e) {
    const handle = e.target.dataset.handle

    this.els.subheading?.elements.forEach(subheadingEl => {
      const subheadingHandle = subheadingEl.dataset.handle

      subheadingEl.setAttribute(
        'aria-current',
        (handle === subheadingHandle).toString(),
      )
    })

    this.els.faq?.elements.forEach(faqEl => {
      const faqHandle = faqEl.dataset.handle

      faqEl.setAttribute('aria-hidden', (handle !== faqHandle).toString())
    })
  }
}

if (!customElements.get('section-faq')) {
  customElements.define('section-faq', SectionFaq)
}
